// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createAsyncAction } from 'typesafe-actions';
import { Note } from '../../../types/Model';

export interface WorkshopNotesRequestPayload {
  id: number;
}
export interface WorkshopNotesSuccessPayload {
  id: number;
  notes: Note[];
}

export interface WorkshopNotesFailPayload {
  error: Error;
}

const getWorkshopNotesDataActions = createAsyncAction(
  'elearning/GET_WORKSHOP_NOTES_DATA',
  'elearning/GET_WORKSHOP_NOTES_DATA_SUCCESS',
  'elearning/GET_WORKSHOP_NOTES_DATA_FAIL'
)<
  WorkshopNotesRequestPayload,
  WorkshopNotesSuccessPayload,
  WorkshopNotesFailPayload
>();

export { getWorkshopNotesDataActions as default }
